<script>
    import {Radar} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Radar,
        mounted() {
            this.renderChart(
                {
                    labels: ['DOMICILIARIO', 'INDUSTRIALES', 'LODOS', 'RESPEL'],
                    datasets: [
                        {
                            label: '2016',
                            backgroundColor: hexToRgba('#00ffed', 70),
                            fill: true,
                            data: ['', '', '', '']
                        },
                        {
                            label: '2017',
                            backgroundColor: hexToRgba('#00ff50', 70),
                            fill: true,
                            data: ['', '', '', '']
                        },
                        {
                            label: '2018',
                            backgroundColor: hexToRgba('#ff9300', 70),
                            fill: true,
                            data: [950, 1450, 1500, 100]
                        }
                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                        }]
                    },
                    maintainAspectRatio: true,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
